import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/main.css';
import 'katex/dist/katex.min.css';
import App from './App';

// If the environment is production, overwrite console.log with an empty function.
// This will disable all console.log statements throughout the entire app.
if (process.env.NODE_ENV === 'production') {
  console.log = () => {}; // Does nothing
  console.warn = () => {}; // Optional: also disable warnings
  console.error = () => {}; // Optional: also disable errors
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);